async function createCard(url, card) {
    url = url + '/v1/card/create'
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(card)
    });
    return await response;
}

export { createCard }